import TypedError from 'error/typed';
import { t } from '@kso/ui/lib/config/locale';

var invalidString = [/[!@#$^*<>?,]+/, t('combine.mainEmp.InvalidNickname')];
var UNCALL = TypedError({
  type: 'wps',
  message: t('logic.QrCode.txt1'),
  title: 'noy try invoke wps api',
  code: 'ignoreApi'
});
var WPSClientErr = TypedError({
  type: 'wps',
  message: '{title}, code: {code}, result: {msg}',
  title: t('logic.FileDownload.txt13'),
  code: null
});
var DocsClientErr = TypedError({
  type: 'docs',
  message: '{title}, code: {code}, result: {msg}',
  title: null,
  code: null
});
var WPSInvokeErr = TypedError({
  type: 'client',
  message: t('logic.QrCode.txt3'),
  title: 'wps invoke fail',
  code: null,
  url: null
});
var ClientErr = TypedError({
  type: 'client',
  title: null,
  result: null,
  status: null,
  code: null,
  message: '{title} client error, code: {code}, result: {result}, status: {status}'
});
var LOIGIN_REQUIRED = ClientErr({
  message: t('logic.FileDownload.txt0'),
  code: 'loginRequired'
});
var GET_TEAM_INFO_FIAL = ClientErr({
  message: t('logic.FileDownload.txt1'),
  code: 'teamidRequired'
});
var FETCH_FILE_FAIL = ClientErr({
  message: t('logic.FileDownload.txt2'),
  code: 'fetchFileDownloadUriFail'
});

// 因为需要添加未能下载的文件列表中
var UNCOMPLETE_DOWNLOAD = {
  message: t('logic.FileDownload.txt3'),
  code: 'downloadFailList'
};

export { ClientErr, DocsClientErr, FETCH_FILE_FAIL, GET_TEAM_INFO_FIAL, LOIGIN_REQUIRED, UNCALL, UNCOMPLETE_DOWNLOAD, WPSClientErr, WPSInvokeErr, invalidString };
